import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession, fetchUserAttributes, signOut } from 'aws-amplify/auth';
import MapView from '../components/MapView';
import Footer from '../components/Footer';
import './AuthenticatedApp.css';

const AuthenticatedApp = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  const [userGroup, setUserGroup] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    loadUserInfo();
  }, []);

  const loadUserInfo = async () => {
    try {
      const attributes = await fetchUserAttributes();
      setUserName(attributes.name || attributes.email || 'User');

      const session = await fetchAuthSession();
      const groups = session.tokens?.accessToken?.payload['cognito:groups'] || [];
      setUserGroup(groups[0] || 'friends');

      setIsAdmin(groups.includes('admin'));
      
      console.log('User info:', { name: attributes.name, groups });
    } catch (error) {
      console.error('Error loading user info:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="authenticated-app">
      <header className="app-header">
        <div className="header-left">
          <img src="/assets/jr-logo.svg" alt="Where's Junior" className="header-logo" />
          <h1>Where's Junior</h1>
        </div>
        <div className="header-controls">
          {isAdmin && (
            <button 
              className="admin-link-button"
              onClick={() => navigate('/admin')}
            >
              🛠️ Admin Panel
            </button>
          )}
          <span className="user-welcome">Welcome, {userName}!</span>
          <button 
            className="logout-button"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </header>
      
      <div className="app-content">
        <MapView showPreciseLocations={true} isAuthenticated={true} />
      </div>

      <Footer />

    </div>
  );
};

export default AuthenticatedApp;